import NpsGauge from './NpsGauge';
export default NpsGauge;



// WEBPACK FOOTER //
// ./src/components/NpsGauge/index.js